import { NetworkStatus } from '@apollo/client';
import { Box } from '@bechtel/gds';
import { map } from 'lodash';
import { Suspense, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import {
  ErrorBoundary,
  MultiLingualText,
  NavBarSkeleton,
  Navbar,
  NotFound,
  SuspenseLoader,
  useLanguage,
} from '~/components';
import { useSearchMetaDataTables } from '~/hooks';
import { jobsiteFeedbackComponents, navbarItems } from './utils';

const JobsiteFeedbackRoutes = ({ routesData }) => {
  const generateRoutes = (data) =>
    map(data, (item) => {
      const path = item.path;
      return { path: `${path}/*`, element: jobsiteFeedbackComponents[path] };
    });
  const updatedRoutes = generateRoutes(routesData);
  updatedRoutes.push({ path: '/*', element: <NotFound /> });
  const routes = useRoutes(updatedRoutes);
  return routes;
};

const JobsiteFeedback = () => {
  const [searchMetadataTables, { loading, error, data, networkStatus }] = useSearchMetaDataTables();
  const { isAlternateLanguageUsed } = useLanguage();

  useEffect(() => {
    searchMetadataTables({
      variables: {
        searchInput: {
          filterInput: {},
          sortInput: [
            {
              field: 'editList',
              sort: 'ASC',
            },
          ],
        },
      },
    });
  }, [searchMetadataTables]);

  const getColumnHeadingByTitle = (title) => {
    const column = data?.searchMetadataTables?.items?.find((item) => item.description === title);
    const columnHeading = (!isAlternateLanguageUsed ? column?.description : column?.alternateDescription) ?? title;
    return columnHeading;
  };
  const navItemsUpdated =
    navbarItems?.map((item) => {
      return { ...item, title: getColumnHeadingByTitle(item.title) };
    }) ?? [];

  return (
    <Box flexGrow={{ sm: '1' }}>
      {(loading || networkStatus === NetworkStatus.refetch) && (
        <Navbar navbarItems={[]}>
          <NavBarSkeleton />
        </Navbar>
      )}
      {!loading && error && (
        <Box>
          <MultiLingualText>Error loading navigation bar.</MultiLingualText>
        </Box>
      )}
      {!loading && !error && (
        <>
          <Navbar navbarItems={navItemsUpdated} />
          <ErrorBoundary>
            <Suspense fallback={<SuspenseLoader />}>
              <JobsiteFeedbackRoutes routesData={navbarItems} />
            </Suspense>
          </ErrorBoundary>
        </>
      )}
    </Box>
  );
};

export default JobsiteFeedback;
